module.exports = __webpack_public_path__ + "static/media/gallery_portland_resourcing.a894bc2d.png";